import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { MoreHorizontal, Scan, Shield, Trash, Edit, RefreshCw } from 'lucide-react';

interface AssetActionsProps {
  assetId: string;
}

export const AssetActions: React.FC<AssetActionsProps> = ({ assetId }) => {
  const handleAction = (action: string) => {
    console.log(`Performing ${action} on asset ${assetId}`);
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild className='disabled:transparent disabled:text-gray-400'>
        <button className="p-2 rounded-lg text-gray-400 disabled:transparent disabled:text-gray-400 hover:text-white hover:bg-gray-800/50 transition-colors" disabled>
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="w-56 bg-[#1A1F2E] rounded-lg p-1.5 shadow-xl border border-gray-800 disabled:transparent disabled:text-gray-400 disabled:cursor-not-allowed"
          sideOffset={5}
          align="end"
        >
          <DropdownMenu.Item
            className="flex items-center px-2 py-2 text-sm text-gray-300 enabled:hover:bg-gray-800/50 rounded-md enabled:cursor-pointer disabled:transparent disabled:text-gray-400 disabled:cursor-not-allowed outline-none"
            onSelect={() => handleAction('scan')}
            disabled
          >
            <Scan className="h-4 w-4 text-blue-500 mr-2" />
            Scan Asset
          </DropdownMenu.Item>
          
          <DropdownMenu.Item
            className="flex items-center px-2 py-2 text-sm text-gray-300 enabled:hover:bg-gray-800/50 rounded-md enabled:cursor-pointer disabled:transparent disabled:text-gray-400 disabled:cursor-not-allowed outline-none"
            onSelect={() => handleAction('security_check')}
            disabled
          >
            <Shield className="h-4 w-4 text-emerald-500 mr-2" />
            Security Check
          </DropdownMenu.Item>

          <DropdownMenu.Item
            className="flex items-center px-2 py-2 text-sm text-gray-300 enabled:hover:bg-gray-800/50 rounded-md enabled:cursor-pointer disabled:transparent disabled:text-gray-400 disabled:cursor-not-allowed outline-none"
            onSelect={() => handleAction('edit')}
            disabled
          >
            <Edit className="h-4 w-4 text-yellow-500 mr-2" />
            Edit Asset
          </DropdownMenu.Item>

          <DropdownMenu.Separator className="h-px bg-gray-800 my-1" />

          <DropdownMenu.Item
            className="flex items-center px-2 py-2 text-sm text-red-400 enabled:hover:bg-gray-800/50 rounded-md enabled:cursor-pointer disabled:transparent disabled:text-gray-400 outline-none"
            onSelect={() => handleAction('delete')}
            disabled
          >
            <Trash className="h-4 w-4 mr-2" />
            Delete Asset
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};